module.exports = __webpack_public_path__ + "static/img/membership-logo.80516f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/membership-logo.png
// module id = 1086
// module chunks = 22 48 49 65